const validationRules = {
  ruleRequired: (v, label = null) =>
    (v !== null && v !== undefined && String(v).trim() !== '') || `El ${label ?? 'campo'} es requerido`,

  ruleMinLengthCardPay: (v, length = 19, label = null) =>
    String(v).trim().length === length || `Los ${label ?? 'dígitos'} deben ser exactamente ${length}`,

  ruleMinLength: (v, length, label = null) =>
    String(v).trim().length >= length || `El ${label ?? 'campo'} debe tener al menos ${length} caracteres`,

  ruleMaxLength: (v, length, label = null) =>
    String(v).trim().length <= length || `El ${label ?? 'campo'} debe tener como máximo ${length} caracteres`,
  ruleTotalMayorCero: (v, label = null) => {
    const total = Number(v || 0);

    return total > 0 || `El ${label ?? 'total'} debe ser mayor a 0`;
  },
  ruleTelephon: value => {
    if (!value) return 'El teléfono es obligatorio';

    const phone = value.replace(/\D/g, '');
    return phone.length === 10 || 'El teléfono debe tener 10 dígitos';
  },
  ruleTelephoneGuion: (v, label = null) =>
  (!v || /^\d{3}-\d{3}-\d{4}$/.test(String(v))) ||
  `El ${label ?? "teléfono"} debe tener formato 444-444-5555`,
  ruleCURP: (v, label = null) =>
    (!!v &&
      /^[A-Z]{4}\d{6}[HM][A-Z]{5}[A-Z0-9]\d$/.test(String(v).toUpperCase())) || `La ${label ?? "CURP"} no es válida`,
  ruleRFC: (v, label = null) =>
    (!!v &&
      /^([A-ZÑ&]{3,4})\d{6}([A-Z0-9]{3})$/.test(String(v).toUpperCase())) ||
    `El ${label ?? "RFC"} no es válido`,

  ruleCp: (v, label = null) =>
    !v || /^[0-9]{5}$/.test(String(v)) || `El ${label ?? 'código postal'} no tiene el formato correcto 5 números`,

  ruleDecimal: ({ v, label = null, decimalPlace = 2, checkOverDecimalOnly = true }) => {
    if (!v) return true;
    const regex = new RegExp(
      `^\\d+(\\.${checkOverDecimalOnly ? '?' : ''}\\d{${checkOverDecimalOnly ? '0,' : ''}${decimalPlace}})?$`
    );
    return regex.test(String(v).replace(/\s/g, '')) ||
      `El ${label ?? 'campo'} debe ser un decimal con hasta ${decimalPlace} decimales`;
  },

  ruleLessThan: (v, target, label = null) =>
    !v || !target || parseFloat(v) < parseFloat(target) || `El ${label ?? 'campo'} debe ser menor que ${target}`,

  ruleGreaterThan: (v, target, label = null) =>
    !v || !target || parseFloat(v) > parseFloat(target) || `El ${label ?? 'campo'} debe ser mayor que ${target}`,

  ruleNumber: (v, label = null) =>
    /^[0-9]+$/.test(String(v)) || `El ${label ?? 'campo'} debe contener solo números`,

  ruleBeforeDate: (v, target, label = null) =>
    !v || !target || new Date(v) < new Date(target) || `El ${label ?? 'campo'} debe ser anterior a ${target}`,

  ruleAfterDate: (v, target, label = null) =>
    !v || !target || new Date(v) > new Date(target) || `El ${label ?? 'campo'} debe ser posterior a ${target}`,

  ruleIs: (v, target, label = null) =>
    !v || !target || v === target || `El ${label ?? 'campo'} debe ser igual a ${target}`,

  ruleEmail: value => {
    if (!value) return 'El correo es obligatorio';

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value) || 'Correo inválido';
  },
  ruleRfc: (v, label = null) =>
    !v || /^([A-ZÑ&]{3,4})\d{6}([A-Z0-9]{3})?$/.test(String(v)) || `Ingresa un ${label ?? 'RFC'} válido`,

  ruleCurp: (v, label = null) =>
    !v || /^[A-Z]{4}\d{6}[HM][A-Z]{5}[A-Z0-9]{2}$/.test(String(v)) || `Ingresa un ${label ?? 'CURP'} válido`,

  ruleNombre: (v, label = null) => {
    const nombre = v || '';
    const etiqueta = label ?? 'nombre';

    if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]*$/.test(nombre)) {
      return `Ingrese un ${etiqueta} válido`;
    }

    if (nombre.length > 50) {
      return `${etiqueta[0]?.toUpperCase() + etiqueta?.slice(1)} debe tener máximo 50 caracteres`;
    }

    return true;
  },
  ruleRef4dig: (v, label = null) =>
    !v || /^[0-9-]+$/.test(String(v)) || `Ingresa un ${label ?? 'detalle'} válido`,

  ruleSelectReq: (v) =>
    (v && typeof v === 'object' && v.id && v.id > 0) || 'La selección es requerida.',

  ruleSelectIdReq: (v) =>
    (v && typeof v === 'object' && v.Id && v.Id > 0) || 'La selección es requerida.',

  ruleSelectDetallepago: (v) =>
    (v && typeof v === 'object' && v.CodPago && v.CodPago > 0) || 'La selección es requerida.',
  ruleSelectIdGenericReq(propName) {
    return (v) => {
      // v puede ser null si el usuario limpia el input
      if (!v) return 'La selección es requerida.';
      // validar que exista la propiedad y no esté vacía
      return (v[propName] !== undefined && v[propName] !== null && v[propName] !== '')
             || 'La selección es requerida.';
    };
  },
  ruleFecha: v => {
    if (!v) return 'La fecha es obligatoria.'

    // Si usas string de fecha (yyyy-mm-dd), convierto a Date
    const fechaSeleccionada = new Date(v)
    const hoy = new Date()
    hoy.setHours(0, 0, 0, 0)

    return fechaSeleccionada <= hoy || 'La fecha no puede ser futura.'
  }
};

export default validationRules;
